module.exports = __webpack_public_path__ + "media/img/trauma-2a50b8016dd9ea2cf1118627f9b922a3.png";